import { createCowLogger } from '@cowprotocol/common-utils'

export const logPriceImpact = createCowLogger('PriceImpact')
